import { gql } from '@apollo/client';
import type { SerializedHardware } from '@enmon/commons/lib/tools';

export const GET_HARDWARE_DATA_LIST = gql`
  query getHardwareData(
    $name: String
    $externalId: String
    $category: [String]
    $sort: [String]
    $limit: Int
    $start: Int
  ) {
    hardwares(
      pagination: { limit: $limit, start: $start }
      sort: $sort
      filters: { name: { containsi: $name }, external_id: { containsi: $externalId }, category: { in: $category } }
    ) {
      data {
        id
        attributes {
          external_id
          name
          disabled
          category
          priority
          reseller {
            data {
              id
              attributes {
                name
              }
            }
          }
          query
          enmon_details
        }
      }
      meta {
        pagination {
          total
        }
      }
    }
  }
`;

export interface HardwareVariables {
  name?: SerializedHardware['name'];
  externalId?: SerializedHardware['external_id'];
  limit: number;
  sort: string[];
  start: number;
  category?: SerializedHardware['category'][];
}

export type HardwaresDataItem = SerializedHardware & {
  id: SerializedHardware['id'];
  name: SerializedHardware['name'];
  reseller: Pick<SerializedHardware['reseller'], 'id' | 'name'>;
  external_id: SerializedHardware['external_id'];
  priority: SerializedHardware['priority'];
  category: SerializedHardware['category'];
  disabled: SerializedHardware['disabled'];
  query: SerializedHardware['query'];
  enmon_details: SerializedHardware['enmon_details'];
};

export interface HardwaresDataList {
  hardwares: {
    data: HardwaresDataItem[];
    meta: { pagination: { total: number } };
  };
}
